module.exports = {
  title: 'Debt Rainbow',
  description: `
    This little tool was something I made for myself to track my student loan paydown 
    progress 😭. I really liked where it was headed, so I decided to hook it up
    to Firebase and share it with other people looking to pay off debt.
  `,
  tags: ['CSS', 'Design', 'Firebase', 'JavaScript', 'React', 'Redux'],
  images: [require('./images/1.png'), require('./images/2.png')],
  url: 'https://debt-rainbow.web.app/',
};



// WEBPACK FOOTER //
// ./src/data/works/debtrainbow/index.js